<script setup>
import {computed, onMounted} from "vue";
import store from "@/store";
import {couponConf} from "@/utils/config";
import router from "@/router";
import HklStoreComponent from "@/components/hkl/HklStoreComponent.vue";
import {useRoute} from "vue-router";

const type = computed(() => {
  let ty = store.state.coupon;
  if (!ty) return {}
  ty = couponConf[ty] || {}
  document.title = ty?.storeName;
  return ty
})
const filters = computed(() => {
  let row = type.value?.storeLst?.row
  if (!row) return [];
  let arr = [];
  row.forEach(item => {
    if(!arr.some(its=>item.area === its.text)){
      arr.push({text: item.area, value: item.area})
    }
  })
  return arr
});
const route = useRoute()
onMounted(() => {
  if(route.query.coupon) store.commit("setCoupon",route.query.coupon)
  else store.commit("getCoupon")
})

const filterHandler = (value, row, column) => {
  const property = column['property'];
  return row[property] === value;
}
</script>

<template>
  <div class="header">
    <div class="back" @click="router.replace({name:'home'})">
      <el-icon size="22">
        <ArrowLeft/>
      </el-icon>
    </div>
    <div>{{ type.storeName }}</div>
    <div></div>
  </div>
  <div class="storeLst" v-if="type.type === 'jd-scal'">
    <el-table :data="type.storeLst?.row" stripe height="100%">
<!--      <el-table-column label="编号" prop="number" align="center"/>-->
      <el-table-column label="门店" prop="store"/>
      <el-table-column label="城市" prop="city"/>
      <el-table-column label="区域" prop="area" :filters="filters" :filter-method="filterHandler" />
      <el-table-column label="地址" prop="address"/>
      <el-table-column label="电话" prop="tel"/>
    </el-table>
  </div>
  <div class="storeLst" v-else-if="type.type === 'hkl'">
    <HklStoreComponent/>
  </div>
  <div class="storeLst" v-else-if="type.type === 'pyf'">
    <el-table :data="type.storeLst?.row" stripe height="100%">
      <!--      <el-table-column label="编号" prop="number" align="center"/>-->
      <el-table-column label="门店" prop="store"/>
<!--      <el-table-column label="城市" prop="city"/>-->
<!--      <el-table-column label="区域" prop="area" :filters="filters" :filter-method="filterHandler" />-->
      <el-table-column label="地址" prop="address"/>
      <el-table-column label="电话" prop="tel"/>
    </el-table>
  </div>
  <div class="storeLst" v-else-if="type.type === 'beiguo'">
    <el-table :data="type.storeLst?.row" stripe height="100%">
      <!--      <el-table-column label="编号" prop="number" align="center"/>-->
      <el-table-column label="门店" prop="store"/>
<!--      <el-table-column label="城市" prop="city"/>-->
<!--      <el-table-column label="区域" prop="area" :filters="filters" :filter-method="filterHandler" />-->
      <el-table-column label="地址" prop="address"/>
      <el-table-column label="电话" prop="tel"/>
    </el-table>
  </div>
</template>

<style scoped lang="less">
.header {
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.storeLst {
  height: calc(100vh - 85px);
  //padding: 0 15px;

  .el-table {
    width: 100%;
  }
}
</style>
